/**
 * @generated SignedSource<<6d301673226353693b344256fd220f76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FreezerInformation_getLocationQuery$variables = {
  id: string;
};
export type FreezerInformation_getLocationQuery$data = {
  readonly getLocation: {
    readonly freezerCredentials: {
      readonly apiKey: string;
      readonly serialNumber: string;
    } | null;
    readonly id: string;
    readonly name: string;
    readonly uuid: string | null;
  };
};
export type FreezerInformation_getLocationQuery = {
  response: FreezerInformation_getLocationQuery$data;
  variables: FreezerInformation_getLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationFreezerDetailObjectType",
        "kind": "LinkedField",
        "name": "freezerCredentials",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "apiKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serialNumber",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreezerInformation_getLocationQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreezerInformation_getLocationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7d53ab4c842e7b52ba41f3c3f6bd5698",
    "id": null,
    "metadata": {},
    "name": "FreezerInformation_getLocationQuery",
    "operationKind": "query",
    "text": "query FreezerInformation_getLocationQuery(\n  $id: String!\n) {\n  getLocation(id: $id) {\n    id\n    uuid\n    name\n    freezerCredentials {\n      apiKey\n      serialNumber\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd9bde4d9d9f39540d9c1a0d6ce79c75";

export default node;
